import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './Components/App';
import * as serviceWorker from './serviceWorker';
import 'fontsource-roboto';
import {initializeApp} from "firebase/app";
import {Router} from '@reach/router'

ReactDOM.render(
    // <React.StrictMode>
        <Router>
            <App path='*'/>
        </ Router>
    // </React.StrictMode>
    , document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();


initializeApp({
    apiKey: "AIzaSyBdLQ0BX2sBRJMD2uGoPPnZYnCS8GAIJ_Y",
    authDomain: "spiro-jayemes.firebaseapp.com",
    projectId: "spiro-jayemes",
});

